import req from "../http";

const manpowerDemand = {
  // 取得 排程(分頁)
  getJobSettingPaging(params) {
    return req("get", "/JobViewer/getJobSetting/paging", params);
  },

  // 取得 需求單資訊
  getManpowerDemandInfo(params) {
    return req("get", "/ManpowerDemandModule", params);
  },

  // 新增 需求單
  postManpowerDemand(params) {
    return req("post", "/ManpowerDemandModule", params);
  },

  // 新增 需求單(SCS)
  postSCSManpowerDemand(params) {
    return req("post", "/SCS/ManpowerModule/New", params);
  },

  // 檢視 需求單(依需求單唯一識別碼)
  getManpowerDemandDetail(guid) {
    return req("get", `/ManpowerDemandModule/${guid}`);
  },

  // 審核 需求單
  postApproved(params) {
    return req("post", "/ManpowerDemandModule/Approved", params);
  },

  // 停用 需求單
  suspendManpowerDemand(guid) {
    return req("post", `/ManpowerDemandModule/Suspend/${guid}`);
  },

  // 啟用 需求單
  rebootManpowerDemand(guid) {
    return req("post", `/ManpowerDemandModule/Reboot/${guid}`);
  },

  // 編輯 已審核完成的需求單
  putApproved(params) {
    return req("put", "/ManpowerDemandModule/Approved", params);
  },

  // 取得 已送審的需求單
  getManpowerDemandStatus(params) {
    return req("get", "/ManpowerDemandModule/WithStatistics", params);
  },

  // 需求單 批次送審且直接結案
  postSendToApproved(params) {
    return req("post", "/ManpowerDemandModule/SendToApproved", params);
  },
};

export default manpowerDemand;